import React from 'react';

// Types ----

type TooltipProps = {
  children: string
}

// Component ----

function Tooltip({children: text}: TooltipProps) {
  return (
    <span className="tooltip rounded shadow px-2 py-1 bg-gray-700 text-gray-50 font-normal text-sm text-pretty bottom-0 mb-3 right-0 mr-3 w-max max-w-72">
      {text}
    </span>
  );
}

// Export ----

export default Tooltip;